// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import App from './App.jsx';
import SideBt from './SideBt.jsx';

import {no_rclick} from './utils.js';
import {SIDEBAR_WIDTH} from './consts.js';

import type {T_Next} from './types.js';

import './css/SideBar.css';


type T_SideBarProps = {
  uname              : string,
  height             : number,
  show_user          : boolean,
  showing_dialog_user: boolean,
  show_bt_crear      : boolean,
  disable_tree_bt    : boolean,
  disable_all        : boolean,
  app                : App
};


type T_SideBarState = {
  bt_active: string
};




export default class SideBar extends Component<T_SideBarProps, T_SideBarState> {
  hide_tree: () => void;
  show_tree: () => void;
  tree_ui  : () => void;
  user_ui  : () => void;
  tools_ui : (next?: T_Next) => void;
  hide_all : (reset_bt: boolean) => void;
  help_ui  : () => void;
  
  
  
  constructor(props: T_SideBarProps) {
    super(props);
    
    this.state = {
      bt_active: 'Mapas'
    };
    
    this.hide_tree = this.hide_tree.bind(this);
    this.show_tree = this.show_tree.bind(this);
    this.tree_ui   = this.tree_ui.bind(this);
    this.user_ui   = this.user_ui.bind(this);
    this.tools_ui  = this.tools_ui.bind(this);
    this.hide_all  = this.hide_all.bind(this);
    this.help_ui   = this.help_ui.bind(this);
    
    this.props.app.sidebar = this;
  }
  
  
  
  hide_all(reset_bt: boolean): void {
    const {app} = this.props;
    
    if (app.dialog_tools != null) {
      this.tools_ui();
    }
    
    if (app.state.show_tree) {
      this.hide_tree();
    }
    
    app.setState({show_dialog_user_edit: false, show_help: false}, () => {
      if (reset_bt) {
        this.setState({bt_active: ''});
      }
    });
  }
  
  
  
  hide_tree(): void {
    this.props.app.setState({show_tree: false});
  }
  
  
  
  show_tree(): void {
    this.props.app.setState({
      show_tree            : true,
      show_dialog_user_edit: false,
      show_dialog_tools    : false,
      show_help            : false
    });
  }
  
  
  
  tree_ui(): void {
    if (this.props.app.state.show_tree) {
      this.hide_tree();
    }
    else {
      this.show_tree();
    }
  }
  
  
  
  user_ui(): void {
    this.hide_tree();
    
    const {app} = this.props;
    
    this.props.app.setState({
      show_dialog_user_edit: ! app.state.show_dialog_user_edit,
      show_dialog_tools    : false,
      show_config_book     : false,
      show_help            : false
    });
  }
  
  
  
  tools_ui(next?: T_Next): void {
    this.hide_tree();
    
    this.props.app.setState({
      show_dialog_tools    : ! this.props.app.state.show_dialog_tools,
      show_dialog_user_edit: false,
      show_help            : false
    }, () => {
      if (next != null && _.isFunction(next)) {
        next(true);
      }
    });
  }
  
  
  
  help_ui(): void {
    this.hide_all(false);
    
    const {app} = this.props;
    
    app.setState({show_help: ! app.state.show_help});
  }
  
  
  
  componentDidUpdate(prevProps: T_SideBarProps, prevState: T_SideBarState) {
    if (this.state.bt_active === 'User' && prevProps.showing_dialog_user && ! this.props.showing_dialog_user) {
      this.setState({bt_active: ''});
    }
  }
  
  
  
  render() {
    const names = this.props.uname.split(' '),
          uname = names.length > 0 ? names[0] : 'Usuario',
          {app} = this.props,
          tree  = {},
          size  = {};
    
    if (app.tree != null) {
      tree.tree = app.tree;
    }
    
    const MIN_H = 860;
    
    if (this.props.height < MIN_H && this.props.height > 800) {
      size.height = Math.max(120, 250 - (MIN_H - this.props.height));
      size.width = 'auto';
      
      size.paddingleft  = ((SIDEBAR_WIDTH - (28 * (size.height / 250))) / 2) + 20;
      size.paddingright = 0;
    }
    
    return (
      <div id='sideBar' style={{height: this.props.height, width: SIDEBAR_WIDTH}} onContextMenu={no_rclick}>
        {(this.props.height > 800) ?
          <img src='./img/Geodatabase.png' alt='logo' className='FckLogo' height={270} width='auto' />
        : (this.props.height > 500 ?
            <img src='./img/gdb.png' alt='logo' className='FckLogo' width='auto' height={150} />
          : 
            null
          )
        }
        
        <div style={{marginTop: this.props.show_user ? 0 : 10}}>
          {this.props.show_user &&
            <SideBt
              icon='user-circle'
              bt_active={this.state.bt_active}
              fun={this.user_ui}
              text={uname}
              small_text={true}
              name='User'
              sidebar={this}
              disabled={this.props.disable_all}
            />
          }
          
          <SideBt
            icon='bars'
            bt_active={this.state.bt_active}
            fun={this.tree_ui}
            text='Mapas'
            small_text={true}
            sidebar={this}
            disabled={this.props.disable_tree_bt || this.props.disable_all}
          />
          
          {(this.props.show_bt_crear) &&
            <SideBt
              icon='wrench'
              bt_active={this.state.bt_active}
              fun={this.tools_ui}
              text='Herramientas'
              small_text={true}
              sidebar={this}
              id='sidebt_tools'
              disabled={this.props.disable_all}
            />
          }
          
          <SideBt
            icon='question-circle'
            bt_active={this.state.bt_active}
            fun={this.help_ui}
            text='Ayuda'
            small_text={true}
            sidebar={this}
            disabled={this.props.disable_all}
          />
        </div>
        
        {(this.props.height > 570) &&
          <img src='./img/logo_agrosat.png' className='logo' alt='logo' />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/SideBar.jsx